import {
  Button,
  DatePicker,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Switch,
  useDisclosure
} from '@nextui-org/react'
import { useFormCampaignContext } from '../hooks/useFormCampaignContext'

const FormStep2 = ({ className, onChange }: any) => {
  const { ctx } = useFormCampaignContext()
  const { isOpen, onOpenChange } = useDisclosure()

  const openModal = (v: boolean) => {
    if (v) {
      onOpenChange()
    } else {
      onChange('active', v)
    }
  }

  return (
    <div className={`w-full space-y-2 py-5 ${className || ''}`}>
      <div className='grid grid-cols-2 gap-4 max-w-3xl mx-auto'>
        <div className='col-span-2'>

          <Input
            label='Monto de aporte'
            type='number'
            placeholder='Ej: 100.00'
            value={ctx.form.amount}
            onChange={(e) => onChange('amount', e.target.value)}
            isRequired
          />
        </div>

        <div>
          <DatePicker
            label='Fecha de inicio'
            value={ctx.form.startDate}
            onChange={(e) => onChange('startDate', e)}
          />
        </div>

        <div>
          <DatePicker
            label='Fecha de término'
            value={ctx.form.endDate}
            onChange={(e) => onChange('endDate', e)}
            isDisabled={ctx.form.isInfinite}
          />
        </div>

        <div>
          <Switch
            isSelected={ctx.form.isInfinite}
            onValueChange={(v) => onChange('isInfinite', v)}
          >
            Infinita <span className='text-xs'>(Durara hasta que se desactive manualmente)</span>
          </Switch>
        </div>
        <div>
          <Switch
            isSelected={ctx.form.active}
            onValueChange={(v) => openModal(v)}
          >
            Activar
          </Switch>
          <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            isDismissable={false}
            isKeyboardDismissDisabled={false}
          >
            <ModalContent>
              {(onClose) => (
                <>
                  <ModalHeader className='flex flex-col gap-1'>Activar</ModalHeader>
                  <ModalBody>
                    <p>
                      Al activar esta campaña, se comenzará a aplicar el aporte a los tradein que cumplan
                      con las condiciones establecidas en la misma. <strong>Se desactivara cualquier otra campaña activa que pueda existir. </strong>
                    </p>
                  </ModalBody>
                  <ModalFooter>
                    <Button color='danger' variant='light' onPress={onClose}>
                      Cancelar
                    </Button>
                    <Button color='primary' onPress={() => { onChange('active', true); onClose() }}>
                      Confirmar
                    </Button>
                  </ModalFooter>
                </>
              )}
            </ModalContent>
          </Modal>
        </div>

        <div>
          {!ctx.form.isInfinite && (
            <Input
              label='Cantidad máxima'
              type='number'
              placeholder='Ej: 500'
              value={ctx.form.maxQuantity}
              onChange={(e) => onChange('maxQuantity', e.target.value)}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default FormStep2
